import { useState, useContext, useEffect } from "react";
import PopupMessage from "../components/common/PopupMessage";
import ConfigContext from "../context/config/ConfigContext";
import AlertContext from "../context/alert/AlertContext";
import screenLookup from "../utils/screenLookup";

const useForm = (options) => {
  //   const [data, setData] = useState(options?.initialValues || {});
  const [showTooltip, setShowTooltip] = useState(false);
  const [fieldRef, setFieldRef] = useState(null);
  //eslint-disable-next-line
  const [screen, setScreen] = useState(options?.screenName || "");
  const [validationMessage, setValidationMessage] = useState(null);
  const [validationControl, setValidationControl] = useState(
    options?.inputList || {}
  );
  // console.log(`Options Input List ${options?.inputList["existingpassword"]}`);
  const [customValidations, setCustomValidations] = useState(
    options?.customRules || {}
  );
  //eslint-disable-next-line
  const [excludeFieldPrefix, setExcludeFieldPrefix] = useState(
    options?.excludePrefix || {}
  );
  const [validationRulesMap, setValidationRulesMap] = useState([]);
  const [validationRules, setValidationRules] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [unformattedValues, setUnformattedValues] = useState(
    options?.unformattedValuesList || {}
  );
  const configContext = useContext(ConfigContext);
  const { loaded, loadConfig, getConfigValue, getConfigValueByCode } =
    configContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts } = alertContext;
  //eslint-disable-next-line
  const [formValue, setFormValue] = useState({});
  const [msgDisplayTime, setMsgDisplayTime] = useState(1000);

  useEffect(() => {
    for (const [key, value] of Object.entries(validationControl)) {
      console.log(`INPUT ${key}: ${value?.current?.value}`);
      setFormValue((formValue) => ({
        ...formValue,
        [key]: value?.current?.value,
      }));
    }
    //eslint-disable-next-line
  }, [validationControl]);

  const Popup = (props) => {
    if (fieldRef) {
      return (
        <PopupMessage
          {...props}
          show={showTooltip}
          message={validationMessage}
          target={fieldRef}
        />
      );
    } else return "";
  };

  const isInValidFormat = (format, value) => {
    // let pattern = "";
    // if (format && format.length > 0) {
    //   pattern = format.slice(1, format.length - 1);
    //   console.log(`Pattern ${pattern} is chnaged`);
    // }
    // const regex = RegExp(pattern);
    // const isValid = regex.test(value);
    // console.log(`value ${value} is matching pattern ${format}: ${isValid} `);
    // const tstPattern = "^\\d+$";
    // const isValid2 = RegExp(tstPattern).test(value);
    console.log(`Pattern ${format} is given`);
    const tstPattern3 = format.replace(/\\\\/g, "\\");
    console.log(`Pattern ${tstPattern3} is given`);
    const isValid3 = RegExp(tstPattern3).test(value);
    // console.log(
    //   `${tstPattern} is matching pattern ${format}: ${tstPattern === format}`
    // );
    // console.log(
    //   `value ${value} is matching pattern ${tstPattern}: ${isValid2} `
    // );
    // console.log(
    //   `value ${value} is matching pattern ${tstPattern3}: ${isValid3} `
    // );
    return isValid3;
  };

  const displayTooltip = () => {
    // const intervalID = setInterval(setShowTooltip(true), 5000);
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
      // clearInterval(intervalID);
    }, msgDisplayTime);
  };
  // const checkPattern = (fieldName, value) => {
  //   value = getUnformttedFieldValue(fieldName, value);
  //   const rule = getFieldValidation(fieldName);
  //   console.log("Rule", rule);
  //   if (rule && rule.pattern && value !== "") {
  //     if (!isInValidFormat(rule.pattern, value)) {
  //       console.log(
  //         "Invalid PATTERN value,",
  //         value,
  //         " ,replace with prev value",
  //         formValue[fieldName]
  //       );
  //       return formValue[fieldName];
  //     } else {
  //       setFormValue((formValue) => ({ ...formValue, [fieldName]: value }));
  //       return value;
  //     }
  //   } else {
  //     setFormValue((formValue) => ({ ...formValue, [fieldName]: value }));
  //     return value;
  //   }
  // };

  const checkField = (fieldName, value) => {
    value = getUnformttedFieldValue(fieldName, value);
    const rule = getFieldValidation(fieldName);
    console.log("Rule", rule);
    console.log("fieldName", fieldName);
    console.log("value", value);
    let customError = "";
    if (customValidations[fieldName]) {
      customError = customValidations[fieldName](value, fieldName);
      console.log("customError", customError);
    }
    if (rule && rule.isUiMandatory === "Y" && value === "") {
      // console.log(`Field ${fieldName} not meeting isUiMandatory`);
      return false;
    } else if (rule && rule.minLength && value.length < rule.minLength) {
      // console.log(`Field ${fieldName} not meeting minLength`);
      return false;
    } else if (
      rule &&
      rule.maxLength &&
      value !== "" &&
      value.length > rule.maxLength
    ) {
      // console.log(`Field ${fieldName} not meeting maxLength`);
      return false;
    } else if (rule && rule.pattern && !isInValidFormat(rule.pattern, value)) {
      // console.log(
      //   `Field ${fieldName} not meeting ${rule.pattern} pattern ${value}`
      // );
      return false;
    } else if (customValidations[fieldName] && customError) {
      //   validationControl[e.target.name].current.setCustomValidity(
      //     `${e.target.name} ${customError}`
      //   );
      console.log(`Field ${fieldName} not meeting custom: ${customError}`);
      return false;
    } else {
      // console.log(`Field ${fieldName} is valid ${value}`);
      return true;
    }
  };

  const getUnformttedFieldValue = (fieldName, value) =>
    unformattedValues[fieldName] !== undefined
      ? unformattedValues[fieldName]
      : value;

  const validateField = (e, label) => {
    if (!validationControl[e.target.name]) return false;
    const value = getUnformttedFieldValue(e.target.name, e.target.value);
    console.log(`Out of ${e.target.name}`);
    const rule = getFieldValidation(e.target.name);
    console.log("Rule", rule);
    console.log("Value", value);
    console.log("Value", typeof value);
    console.log("Length", value.toString().length);
    // console.log("Validation Ctrls ", validationControl);
    // console.log("Validation Ctrl", validationControl[e.target.name]);
    var prefix;
    if (label) {
      prefix = label;
    } else {
      prefix = excludeFieldPrefix[e.target.name] ? "" : e.target.placeholder;
    }
    let customError = "";
    if (customValidations[e.target.name]) {
      customError = customValidations[e.target.name](value, e.target.name);
      console.log("Custom Error ", customError);
    }
    if (
      rule &&
      rule.isUiMandatory === "Y" &&
      validationControl[e.target.name].current.value === ""
    ) {
      // if (e.target.value === "") {
      console.log(`Validation Error:${e.target.name} can not be blank`);
      displayTooltip();
      setFieldRef(validationControl[e.target.name]);
      setValidationMessage(`${prefix} can not be blank`);
      e.target.classList.add("wrong-input");
    } else if (
      rule &&
      rule.minLength &&
      value !== "" &&
      value.length < rule.minLength
    ) {
      console.log(`Validation Error:${e.target.name} too short`);
      displayTooltip();
      setFieldRef(validationControl[e.target.name]);
      setValidationMessage(
        `${prefix} is too short. ${e.target.placeholder} must be at least ${rule.minLength} characters`
      );
      e.target.classList.add("wrong-input");
    } else if (rule && rule.maxLength && value.length > rule.maxLength) {
      console.log(`Validation Error:${e.target.name} too long`);
      displayTooltip();
      setFieldRef(validationControl[e.target.name]);
      setValidationMessage(
        `${prefix} is too long. ${e.target.placeholder} can not exceed ${rule.maxLength}`
      );
      e.target.classList.add("wrong-input");
    } else if (
      rule &&
      rule.pattern &&
      value !== "" &&
      !isInValidFormat(rule.pattern, value)
    ) {
      console.log(
        `Validation Error:${e.target.name} not valid ${value} per pattern ${rule.pattern}`
      );
      displayTooltip();
      setFieldRef(validationControl[e.target.name]);
      setValidationMessage(`${prefix} is not valid`);
      e.target.classList.add("wrong-input");
    } else if (customValidations[e.target.name] && customError) {
      //   validationControl[e.target.name].current.setCustomValidity(
      //     `${e.target.name} ${customError}`
      //   );
      // console.log(
      //   `Validation Error:${e.target.name} does not match custom criteria`
      // );
      displayTooltip();
      console.log("e.target.className", e.target.className);
      setFieldRef(validationControl[e.target.name]);
      setValidationMessage(`${prefix} ${customError}`);
      e.target.classList.add("wrong-input");
    } else {
      e.target.classList.remove("wrong-input");
      setShowTooltip(false);
      setFieldRef(null);
    }
    // if (rule.isUiMandatory === "Y" && e.target.value === "") {
    //   setErrorMessage(`${e.target.name} can not be blank`);
    // } else {
    // console.log(
    //   "Validation ",
    //   validationControl[e.target.name].current.validity
    // );
    // console.log("Validation Ctrl ", validationControl[e.target.name].current);
    // }
  };

  const validateAllFields = () => {
    console.log("Validating all fields", validationControl);
    for (const element in validationControl) {
      // console.log("Element ", validationControl[element]);
      // console.log("Element ", element);
      // validationControl.forEach((element) => {
      //   console.log("Field Validity:", validationControl[element].current);
      //   console.log("Custom Validity:", customValidations);
      //   console.log("Custom Validity:", validationControl[element]);
      //   console.log("Custom Validity Function:", customValidations[element]);
      //   console.log(
      //     "Custom Validity Value:",
      //     validationControl[element].current.value
      //   );
      //   console.log(
      //     "Custom Validity:",
      //     customValidations[element] &&
      //       customValidations[element](
      //         validationControl[element].current.value
      //       ) !== ""
      //   );
      // console.log("unformattedValues:", unformattedValues[element]);
      // console.log("validationControl:", validationControl[element]);
      let fieldValue = "";
      let isMandatory = false;
      if (unformattedValues && unformattedValues[element]) {
        fieldValue = unformattedValues[element];
        console.log("Check for unformatted", unformattedValues);
      } else if (
        validationControl &&
        validationControl[element] &&
        validationControl[element].current
      ) {
        // console.log("Check for fieldValue");
        fieldValue = validationControl[element].current.value;
        isMandatory = validationControl[element].current["required"];
      }
      console.log("Check for element fieldValue", element, fieldValue);
      if (fieldValue) {
        const checkResult = checkField(element, fieldValue);
        // console.log("Feild is valid??", checkResult);
        if (!checkResult) return false;
      } else if (isMandatory && !fieldValue) {
        return false;
      }
      // else {
      //   // console.log("Feild not valid", fieldValue);
      //   return true;
      // }
    }
    return true;
  };

  const getFieldValidation = (field) => {
    // console.log("RULES:", validationRules);
    return validationRules.filter(
      (item) =>
        item.screenName === screenLookup[screen].screenName &&
        item.property === field
    )[0];
  };

  const getValidationRules = (lookup) => {
    // console.log("RULE lookup:", lookup);
    // console.log("RULE lookup Map:", validationRulesMap);
    // let config = null;
    const rulesMap = validationRulesMap.filter((item) => {
      //   console.log("RULE lookup item:", item);
      // if (
      //   item.action === lookup.action &&
      //   item.function === lookup.function &&
      //   item.version === lookup.version
      // ) {
      //   console.log("RULE lookup item:", item);
      // }

      return (
        item.action === lookup.action &&
        item.function === lookup.function &&
        item.version === lookup.version
      );
    });
    // console.log("RULE MAP:", rulesMap);
    let selectedRule = [];
    if (rulesMap.length > 0 && rulesMap[0].applicationResourceValidations) {
      selectedRule = rulesMap[0].applicationResourceValidations.filter(
        (item) => {
          return item.screenName === lookup.screenName;
        }
      );
    }
    return selectedRule;
  };

  useEffect(() => {
    const getConfigDetails = async () => {
      // console.log("CONFIG LOADing");

      try {
        const res = await loadConfig();
        // console.log("CONFIG RULE MAP", res);
        setValidationRulesMap((items) => [...items, ...res]);
        // setValidationRulesMap(res);
      } catch (err) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger");
      }
    };

    // if (!loading && !loaded) {
    getConfigDetails();
    // console.log("CONFIG LOADED");
    // }

    // setCustomValidations({ ...customValidations, username: isValidEmail });
    // return () => {
    //   validationRules = [];
    // };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (loaded) {
      const msgDisplayTime =
        getConfigValue(
          "generalConfig",
          "Message_Display_Duration",
          "App_Config"
        ) * 1000;
      setMsgDisplayTime(msgDisplayTime);
    }
    //eslint-disable-next-line
  }, [loaded]);

  useEffect(() => {
    // console.log("CONFIG LOADED...");
    // console.log("Validation Rules Map:", validationRulesMap);
    if (validationRulesMap.length > 0 && validationRules.length === 0) {
      // console.log("screen ", screenLookup[screen]);
      const validationRules = getValidationRules(screenLookup[screen]);
      // console.log("rule ", validationRules);
      setValidationRules(validationRules);
    }
    //eslint-disable-next-line
  }, [validationRulesMap]);

  useEffect(() => {
    console.log("Validation Rules:", validationRules);
    if (validationRules.length > 0) {
      // console.log("Validations Set");
      for (const element in validationControl) {
        const rule = getFieldValidation(element);
        // console.log("Validations Set Rule", rule);
        if (
          rule &&
          validationControl[element] &&
          validationControl[element].current
        ) {
          // if (validationControl[element].current)
          //   console.log(
          //     "Validations Set to field",
          //     validationControl[element].current
          //   );
          // if (rule.minLength)
          //   validationControl[element].current["minLength"] = rule.minLength;
          // if (rule.maxLength)
          //   validationControl[element].current["maxLength"] = rule.maxLength;
          // if (rule.pattern)
          //   validationControl[element].current["pattern"] = rule.pattern;
          if (rule["isUiMandatory"] === "Y")
            validationControl[element].current["required"] = true;
        }
        const isValid = validateAllFields();
        setIsFormValid(isValid);
      }
    }
    //eslint-disable-next-line
  }, [validationRules, validationControl]);

  return {
    Popup,
    showTooltip,
    setShowTooltip,
    fieldRef,
    setFieldRef,
    validationMessage,
    setValidationMessage,
    validationControl,
    setValidationControl,
    validateField,
    validateAllFields,
    customValidations,
    setCustomValidations,
    isFormValid,
    setIsFormValid,
    unformattedValues,
    setUnformattedValues,
  };
};

export default useForm;
